/**
 * TODO: To replace the view logic in Container.js
 * NOT IN USE YET.
 */

var VRC = VRC || {};

VRC.ContainerView = (function(){

  var _containerModel;
  var _containerQuery = '.deck';
  var _template = 'containerView';


  var getId = function(){

  };

  var setBackgroundColor = function(){

  };

  var attachEvents = function(){
    attachDraggable();
    attachEditModal();
    attachViewModal();
  };

  var rotate = function(){

  };

  var attachDraggable = function(){

  };

  var attachEditModal = function(){

  };

  var attachViewModal = function(){

  };

  var init = function(model){
      _containerModel = model;
  };

  var render = function(){
      attachEvents();
      var ctx = _containerModel.toJson();

      var html = WELL.Handlebars.VRC[_template](ctx);


  };

  var update = function(){

  };

  return {
    init : init,
    render : render,
    update : update
  }
});
